import Vue from 'vue'
import Vuex from 'vuex'
import theme from './modules/theme'
import devices from './modules/devices'
import filters from './modules/filters'
import settings from './modules/settings'
import observations from './modules/observations'
import combinationChart from './modules/combinationChart'
import deviceObservationStatuses from './modules/deviceObservationStatuses'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        theme, devices, filters, settings, observations, combinationChart, deviceObservationStatuses
    }
})


// WEBPACK FOOTER //
// ./src/app/store/index.js